import React from 'react';
import { useParams } from 'react-router-dom';

import AssignmentUpdateForm from 'components/Assignment/AssignmentUpdateForm/AssignmentUpdateForm';

const AssignmentUpdatePage: React.FC = () => {
  const { accountId = '', projectId = '', positionId = '', assignmentId = '' } = useParams();

  return (
    <AssignmentUpdateForm
      accountId={accountId}
      projectId={projectId}
      positionId={positionId}
      assignmentId={assignmentId}
    />
  );
};

export default AssignmentUpdatePage;
